import { AlertTriangle } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog'
import { useTranslations } from '../providers/ContactServiceProvider'

export interface DeleteDefaultConfirmationDialogProps {
  open: boolean
  /** When true, shows the default-contact variant with dynamic names */
  isDefaultDelete?: boolean
  defaultContactName?: string
  newDefaultName?: string
  onConfirm: () => void
  onCancel: () => void
}

export function DeleteDefaultConfirmationDialog({
  open,
  isDefaultDelete = false,
  defaultContactName = '',
  newDefaultName = '',
  onConfirm,
  onCancel,
}: DeleteDefaultConfirmationDialogProps) {
  const t = useTranslations()

  const title = isDefaultDelete ? t.dialog.deleteDefault.title : t.dialog.delete.title
  const message = isDefaultDelete
    ? t.dialog.deleteDefault.message(defaultContactName, newDefaultName)
    : t.dialog.delete.message
  const cancelLabel = isDefaultDelete ? t.dialog.deleteDefault.cancel : t.dialog.delete.cancel
  const confirmLabel = isDefaultDelete ? t.dialog.deleteDefault.confirm : t.dialog.delete.confirm

  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onCancel() }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex flex-col items-center gap-3 text-center">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900">
              <AlertTriangle className="h-6 w-6 text-amber-500" />
            </div>
            <AlertDialogTitle className="text-content-primary dark:text-dark-content-primary">
              {title}
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-center">
            {message}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex justify-center gap-3 sm:justify-center">
          <AlertDialogCancel className="text-primary-600 hover:text-primary-700 dark:text-dark-content-custom">
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-red-600 text-white hover:bg-red-700 dark:bg-red-600 dark:hover:bg-red-700"
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
